import { map, trim, uniq, compact, isString } from "lodash";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Select from "antd/lib/select";
import Modal from "antd/lib/modal";
import { wrap as wrapDialog, DialogPropType } from "@/components/dialog-wrapper/DialogWrapper";
import { useTheme } from "@/components/ThemeProvider";

function EditTagsDialog({ dialog, tags, getAvailableTags }) {
  const [availableTags, setAvailableTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [values, setValues] = useState(() => uniq(compact(map(tags, tag => isString(tag) ? trim(tag) : null))));
  const [selectRef, setSelectRef] = useState(null);
  const { isDarkMode } = useTheme();

  useEffect(() => {
    if (selectRef && !isLoading) {
      selectRef.focus();
    }
  }, [selectRef, isLoading]);

  useEffect(() => {
    let isCancelled = false;
    getAvailableTags().then(availableTags => {
      if (!isCancelled) {
        setAvailableTags(uniq(compact(map(availableTags, tag => isString(tag) ? trim(tag) : null))));
        setIsLoading(false);
      }
    });
    return () => {
      isCancelled = true;
    };
  }, [getAvailableTags]);

  return (
    <Modal
      {...dialog.props}
      onOk={() => dialog.close(values)}
      title="Add/Edit Tags"
      className={`shortModal ${isDarkMode ? 'dark-mode' : ''}`}
      wrapProps={{ "data-test": "EditTagsDialog" }}>
      <Select
        ref={setSelectRef}
        mode="tags"
        className={`w-100 ${isDarkMode ? 'dark-mode' : ''}`}
        placeholder="Add some tags..."
        defaultValue={values}
        onChange={v => setValues(compact(map(v, tag => isString(tag) ? trim(tag) : null)))}
        disabled={isLoading}
        loading={isLoading}
        dropdownClassName={isDarkMode ? 'dark-mode' : ''}>
        {map(availableTags, tag => (
          <Select.Option key={tag}>{tag}</Select.Option>
        ))}
      </Select>
    </Modal>
  );
}

EditTagsDialog.propTypes = {
  dialog: DialogPropType.isRequired,
  tags: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])), // handle both strings and objects
  getAvailableTags: PropTypes.func.isRequired,
};

EditTagsDialog.defaultProps = {
  tags: [],
};

export default wrapDialog(EditTagsDialog);
